<template>
  <div class="card">
    <div class="card-header">
      <span>举报信息</span>
    </div>
    <div class="card-body">
        <z-row>
        <z-col span='5'>举报类型</z-col>
        <z-col span='19'>{{infoData.reason}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>举报时间</z-col>
        <z-col span='19'>{{infoData.time}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>对方昵称</z-col>
        <z-col span='19'>{{infoData.nickname}}</z-col>
      </z-row>
      <z-row v-if="infoData.userRole">
        <z-col span='5'>用户身份</z-col>
        <z-col span='19'>{{infoData.userRole}}</z-col>
      </z-row>
      <z-row v-if="infoData.lossType">
        <z-col span='5'>交易渠道</z-col>
        <z-col span='19'>{{infoData.lossType}}</z-col>
      </z-row>
      <z-row v-if="infoData.orderId">
        <z-col span='5'>订单编号</z-col>
        <z-col span='19'>{{infoData.orderId}}</z-col>
      </z-row>
      <z-row v-if="infoData.moneyLoss > 0">
        <z-col span='5'>损失金额</z-col>
        <z-col span='19'>{{infoData.moneyLoss}}元</z-col>
      </z-row>
      <z-row v-if="infoData.queryType">
        <z-col span='5'>问题类型</z-col>
        <z-col span='19'>{{infoData.queryType}}</z-col>
      </z-row>
      <z-row v-if="infoData.reportTypeId == '5'">
        <z-col span='5'>私信内容</z-col>
        <z-col span='19'>已上传</z-col>
      </z-row>
      <z-row v-if="infoData.productCategory">
        <z-col span='5'>商品品类</z-col>
        <z-col span='19'>{{infoData.productCategory}}</z-col>
      </z-row>
      <z-row v-if="['1', '15', '17'].includes(infoData.reportTypeId)">
        <z-col span='5'>举报商品</z-col>
        <z-col span='19'><div v-html="reportProduct"></div></z-col>
      </z-row>
      <z-row v-if="infoData.phoneQuestionDesc">
        <z-col span='5'>质量问题</z-col>
        <z-col span='19'>{{infoData.phoneQuestionDesc}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>问题描述</z-col>
        <z-col span='19'>{{infoData.content}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>上传凭证</z-col>
        <z-col span='19'>
          <ImageList :infoList="pics"></ImageList>
        </z-col>
      </z-row>
      <z-row v-if="infoData.outsideCommunication">
        <z-col span='5'>站外沟通</z-col>
        <z-col span='19'>{{ infoData.outsideCommunication }}</z-col>
      </z-row>
      <z-row v-if="outSidePics.length > 0">
        <z-col span='5'>站外凭证</z-col>
        <z-col span='19'>
          <ImageList :infoList="outSidePics"></ImageList>
        </z-col>
      </z-row>
    </div>
  </div>
</template>

<script>
import { Row, Col } from '@zz-common/zz-ui';
import ImageList from '../ImageList'
export default {
  name: 'InfoCard',
  props: {
    infoData: {
      default: () => {}
    }
  },
  components: {
    'z-row': Row,
    'z-col': Col,
    ImageList
  },
  data() {
    return {
      type: {
        1: '商品',
        2: '私信',
        3: '订单',
        4: '其他',
        5: '视频',
        6: '图片',
        7: '短视频',
        8: 'url',
        9: '帖子',
        11: '直播'
      }
    }
  },
  computed: {
    pics() {
      const { pics = '' } = this.infoData
      if (pics === '' || pics === ',') return []
      let res = []
      try {
        res = JSON.parse(pics)
      } catch {
        res = []
      }
      return res
    },
    outSidePics() {
      const { outsidePic = '' } = this.infoData
      if (outsidePic === '' || outsidePic === ',') return []
      let res = []
      try {
        res = JSON.parse(outsidePic)
      } catch {
        res = []
      }
      return res
    },
    reportProduct() {
      const { evidenceList = [] } = this.infoData
      return evidenceList.map(t => {
        return `<div style="overflow:hidden; text-overflow: ellipsis; white-space: nowrap">${t.content}</div>`
      }).join('')
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>